import {ChangeDetectionStrategy, Component, computed, input} from "@angular/core";
import {ColumnType} from "../table/harbour-dues-rotterdam-pro-forma-column.directive";
import {HarbourDuesDeclaration} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
  selector: "app-harbour-dues-rotterdam-pro-forma-invoice-skeleton",
  templateUrl: "./harbour-dues-rotterdam-pro-forma-invoice-skeleton.component.html",
  styleUrl: "./harbour-dues-rotterdam-pro-forma-invoice-skeleton.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HarbourDuesRotterdamProFormaInvoiceSkeletonComponent {
  protected readonly ColumnType = ColumnType;

  readonly declaration = input<HarbourDuesDeclaration>();

  protected readonly cargoTypes = computed(() => {
    const berthVisits = this.declaration()?.visit?.berthVisits || [];
    const cargoTypes = berthVisits.flatMap(berthVisit => {
      const loadedCargoTypes = berthVisit?.loadedGoods?.map(
        goods => goods.cargoType
      ) || [];
      const dischargedCargoTypes = berthVisit?.dischargedGoods?.map(
        goods => goods.cargoType
      ) || [];
      return [...loadedCargoTypes, ...dischargedCargoTypes];
    }).filter(cargoType => cargoType !== null);
    const uniqueCargoTypes = [...new Set(cargoTypes)];
    return uniqueCargoTypes.length > 0 ? uniqueCargoTypes :[''];
  });
}
